<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <circle cx="12" cy="12" r="11" fill="#fff"/>
  <path stroke="#000" stroke-width="2" d="M4.5 5L19 19.826M12 22.5c5.799 0 10.5-4.701 10.5-10.5 0-5.8-4.701-10.5-10.5-10.5S1.5 6.2 1.5 12c0 5.799 4.701 10.5 10.5 10.5z"/>
</svg>
